<template>
  <div class="margen_total">
    <div v-if="!dataLoaded" class="loading-spinner">
      <i class="fa-solid fa-spinner fa-spin"></i>
      <div class="spinner"></div>
    </div>
    <Tabla
      v-if="dataLoaded && cpaInfo.length > 0"
      :Info="cpaInfo"
      :subnum1="cpapendientes"
      :subnum2="cpapendientes3meses"
      :columnHeaders="
        selectedClient?.name_CL === 'GENERAL'
          ? [
              'Cliente',
              'Número de CPA',
              'PPU',
              'Costo',
              'Cargos',
              'Fecha Apertura',
              'Días Aperturado',
              'Nombre Supervisor',
              'Oficina',
            ]
          : [
              'Número de CPA',
              'PPU',
              'Costo',
              'Cargos',
              'Fecha Apertura',
              'Días Aperturado',
              'Nombre Supervisor',
              'Oficina',
            ]
      "
      :rowFields="
        selectedClient?.name_CL === 'GENERAL'
          ? [
              { key: 'CLIENTE', format: 'text' },
              { key: 'CODIGO_CPA', format: 'number' },
              { key: 'PPU', format: 'text' },
              { key: 'CPA', format: 'currency' },
              { key: 'Cargos', format: 'currency' },
              { key: 'FECHA_APERTURA', format: 'date' },
              { key: 'DIAS_APERTURADO', format: 'number' },
              { key: 'Nombre_Supervisor', format: 'text' },
              { key: 'Oficina', format: 'text' },
            ]
          : [
              { key: 'CODIGO_CPA', format: 'number' },
              { key: 'PPU', format: 'text' },
              { key: 'CPA', format: 'currency' },
              { key: 'Cargos', format: 'currency' },
              { key: 'FECHA_APERTURA', format: 'date' },
              { key: 'DIAS_APERTURADO', format: 'number' },
              { key: 'Nombre_Supervisor', format: 'text' },
              { key: 'Oficina', format: 'text' },
            ]
      "
      :numColspan="selectedClient?.name_CL === 'GENERAL' ? 9 : 8"
      :dataColspan="5"
      :subnumColspan="5"
      :enablePopup="false"
      :disabled="false"
      :enableFilters="
        selectedClient?.name_CL === 'GENERAL'
          ? [true, true, true, true, true, true, true, true, true]
          : [true, true, true, true, true, true, true, true]
      "
      subtable1="# CPA pendientes"
      subtable2="# CPA sobre 3 meses"
      tableTitle="CPA pendientes"
    />

    <p v-if="dataLoaded && cpaInfo.length === 0">
      El cliente {{ selectedClient.name_CL }} no presenta CPA pendientes.
    </p>
  </div>
</template>

<script setup>
import { computed, onMounted, ref } from "vue";
import Tabla from "../components/Tabla_botones.vue";
import { useClientStore } from "../stores/clientStore.js";
import { useSupStore } from "../stores/supStore.js";
import useUserStore from "../stores/userStore.js";
import { getReporteCPA } from "../api/cpa.js";
import {
  formatNumber,
  formatDate,
  formatCurrency,
  normalizeName,
} from "../utils/formatters";

const cpaInfo = ref([]);
const cpapendientes = ref(null);
const cpapendientes3meses = ref(null);

const dataLoaded = ref(false);

const clientStore = useClientStore();
const selectedClient = computed(() => clientStore.selectedClient);

const supStore = useSupStore();
const selectedSup = computed(() => supStore.selectedSup);

const userStore = useUserStore();
const userRole = userStore.user?.rol;
const userId = userStore.user?.id;

const loadData = async () => {
  try {
    let Sup_Cod_Cartera = null;

    if (userRole === "admin" && selectedSup.value.name_SU === "GENERAL") {
      Sup_Cod_Cartera = null;
    } else if (userRole === "manager" && !selectedSup.value) {
      Sup_Cod_Cartera = userId;
    } else if (selectedSup.value && selectedSup.value.unikey_SU) {
      Sup_Cod_Cartera = selectedSup.value.unikey_SU;
    }

    const fecha = new Date().toISOString().split("T")[0];

    let ClienteId = null;

    if (selectedClient.value && selectedClient.value.name_CL === "GENERAL") {
      ClienteId = null;
    } else if (selectedClient.value) {
      ClienteId = selectedClient.value.unikey_CL;
    }

    const response = await getReporteCPA(fecha, Sup_Cod_Cartera, ClienteId);

    const reporteCPA = response.datacpa;

    const valoresNumericos = response.valores_Numericos;

    if (valoresNumericos.length > 0) {
      cpapendientes.value = valoresNumericos[0].pendientes;
      cpapendientes3meses.value = valoresNumericos[0].mayor3Meses || 0;
    }

    if (Array.isArray(reporteCPA)) {
      cpaInfo.value = reporteCPA.map((item) => ({
        ...item,
        CLIENTE: normalizeName(item["CLIENTE"]),
        PPU: item.PPU?.trim() ? item.PPU : "No registra patente",
        Nombre_Supervisor: normalizeName(item["Nombre_Supervisor"]),
        CPA: formatCurrency(item["CPA"]),
        Cargos: formatCurrency(item["Cargos"]),
        FECHA_APERTURA: formatDate(item.FECHA_APERTURA),
        DIAS_APERTURADO: formatNumber(item["DIAS_APERTURADO"]),
        Id_Supervisor: formatNumber(item["Id_Supervisor"]),
        Id_Cliente: formatNumber(item["Id_Cliente"]),
      }));
    }

    dataLoaded.value = true;
  } catch (error) {
    console.error("Error al obtener la información:", error);
    dataLoaded.value = true;
  }
};

onMounted(loadData);
</script>

<style scoped>
@import "../css/spinner.css";
</style>
